import { createSelector } from "reselect";
import { AppState } from "src/features";

export const getRestaurantFlags = (state: AppState) => state.restaurantFlags || {};

export const restaurantAdUnitEnabled = createSelector(getRestaurantFlags, (flags) => flags.quickSellEnabled);

export const getIsSalesMode = createSelector(getRestaurantFlags, (flags) => flags.salesMode);

export const getIsOrderHeadCountEnabled = createSelector(getRestaurantFlags, (flags) => flags.enableOrderHeadCount);

export const getCustomFeedback = createSelector(
    getRestaurantFlags,
    ({ customFeedbackUrl: url, customFeedbackButtonText: buttonText }) => ({ url, buttonText })
);

export const getDietaryInformationUrl = createSelector(getRestaurantFlags, (flags) => flags.dietaryInformationUrl);

export const getFacebookPixelId = createSelector(getRestaurantFlags, (flags) => flags.facebookPixelId);

export const getGuestPlatformFeeEnabled = createSelector(
    getRestaurantFlags,
    (flags) => flags.guestPlatformFeeEnabled === true
);
